export const REPLY_ON_THREAD = 'REPLY_ON_THREAD';
export const REPLY_TO_MESSAGE = 'REPLY_TO_MESSAGE';
export const FORWARD_MESSAGE = 'FORWARD_MESSAGE';